import { render, staticRenderFns } from "./CbsBudgetTripTable.vue?vue&type=template&id=2f73d41f&scoped=true"
import script from "./CbsBudgetTripTable.vue?vue&type=script&lang=js"
export * from "./CbsBudgetTripTable.vue?vue&type=script&lang=js"
import style0 from "./CbsBudgetTripTable.vue?vue&type=style&index=0&id=2f73d41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73d41f",
  null
  
)

export default component.exports